module.exports = __webpack_public_path__ + "img/icon_map_63_off_101.0fad8146.png";